export const AGENT_CREATE_RESET = 'AGENT_CREATE_RESET';
export const AGENT_CREATE_SET_CREATED = 'AGENT_CREATE_SET_CREATED';
export const AGENT_CREATE_SET_ERROR = 'AGENT_CREATE_SET_ERROR';
export const AGENT_CREATE_SET_VIOLATIONS = 'AGENT_CREATE_SET_VIOLATIONS';
export const AGENT_CREATE_TOGGLE_LOADING = 'AGENT_CREATE_TOGGLE_LOADING';
